import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function checkFeedback(body, authHeaders) {
    return await fetchAndParse(`${API_URL}/p/feedback`, {
        headers: { ...jsonHeaders, ...authHeaders },
        method: 'PUT',
        body: JSON.stringify(body)
    })
}

export function useFeedbacks() {
    return useAuthMutation({
        mutationFn: checkFeedback,
        onSuccess: (res) => {
            console.log(res)
        },
    });
}